module.exports = __webpack_public_path__ + "fonts/Charlie_Text-Semibold.6bf4f469d75e8cb1428c.woff2";